import { clsx } from 'clsx';
import Skeleton from 'react-loading-skeleton';
import { Link, useLocation } from 'react-router';

import { useGetUser } from '@/api';
import { appRoutes } from '@/routes/app-routes.ts';
import { useAuthStore, useModalStore } from '@/store';

import { SignUpIcon, UserIcon } from '../icons/header';
import { ArrowIcon } from '../icons/main-block';
import { BurgerMenu } from './BurgerMenu/BurgerMenu.tsx';
import cn from './styles.module.scss';

export const Header = () => {
    const { pathname } = useLocation();
    const { setIsOpen, setIsAuthHidden, setShowSignUp } = useModalStore();
    const { token, isAuth } = useAuthStore();
    const { data: userData } = useGetUser();

    const UserName = userData ? (
        <>
            <span>{UserIcon} </span>
            <span> Привет, {userData.firstname}</span>
        </>
    ) : (
        <Skeleton width={200} height={17} />
    );

    const handleOpen = () => {
        if (!isAuth) {
            setShowSignUp(true);
            setIsOpen(true);
            setIsAuthHidden(false);
        }
    };

    const handleOpenFromMenu = (signingUp: boolean) => {
        setIsOpen(true);
        setIsAuthHidden(false);
        setShowSignUp(signingUp);
    };

    return (
        <nav className={clsx(cn.navBar, pathname !== appRoutes.mainPage && cn.hideOnMob)}>
            <div className={cn.navBarContainer}>
                <div className={cn.navBarLeft}>
                    <Link to="/">
                        <img src="/images/icons/logo_white.svg" width={96} height={32} alt="" />
                    </Link>
                </div>

                <div className={cn.navBarRight}>
                    <div onClick={handleOpen} className={cn.signUp}>
                        {token ? (
                            UserName
                        ) : (
                            <>
                                <span className={cn.signUpIcon}>{SignUpIcon}</span>
                                <span> Зарегистрироваться или войти</span>
                                <span className={cn.signUpIconMob}>{ArrowIcon}</span>
                            </>
                        )}
                    </div>
                    <div className={cn.menuContainer}>
                        <BurgerMenu onClick={handleOpenFromMenu} />
                    </div>
                </div>
            </div>
        </nav>
    );
};
